import { Injectable, inject } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { API_BASE_URL } from '../config/api.config';
import { Brand, BrandRequest } from '../models/brand.model';
import { BrandCategoryCard } from '../models/category.model';

@Injectable({ providedIn: 'root' })
export class BrandService {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${API_BASE_URL}/brands`;

  getAll(search?: string): Observable<Brand[]> {
    let params = new HttpParams();
    if (search?.trim()) {
      params = params.set('search', search.trim());
    }
    return this.http.get<Brand[]>(this.baseUrl, { params });
  }

  getById(id: string): Observable<Brand> {
    return this.http.get<Brand>(`${this.baseUrl}/${id}`);
  }

  getCategories(brandId: string): Observable<BrandCategoryCard[]> {
    return this.http.get<BrandCategoryCard[]>(`${this.baseUrl}/${brandId}/categories`);
  }

  create(request: BrandRequest): Observable<Brand> {
    return this.http.post<Brand>(this.baseUrl, request);
  }

  update(id: string, request: BrandRequest): Observable<Brand> {
    return this.http.put<Brand>(`${this.baseUrl}/${id}`, request);
  }

  delete(id: string): Observable<void> {
    return this.http.delete<void>(`${this.baseUrl}/${id}`);
  }

  uploadLogo(id: string, file: File): Observable<Brand> {
    const form = new FormData();
    form.append('file', file, file.name);
    return this.http.post<Brand>(`${this.baseUrl}/${id}/logo`, form);
  }

  deleteLogo(id: string): Observable<Brand> {
    return this.http.delete<Brand>(`${this.baseUrl}/${id}/logo`);
  }
}
